/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=a54af300"
const script = {}

import exportComponent from "/Users/huangzhichao/Code/beyoung/weitu_land_page_h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__